<template>
  <v-card>
    <v-card-title primary-title >
      <div class="headline" color="text--primary">
        {{ asModel.portname }}
      </div>
    </v-card-title>
    <v-container fluid>
      <v-layout col wrap>
        <v-flex sx12 sm2>
          <v-card flat>
            <v-card-title class="body-2" color="text--primary" >
              Start Date
            </v-card-title>
            <span class="heading ma-5">
              {{ asModel.startDate | date }}
            </span>
            <v-card-title class="body-2" color="text--primary" >
               Status
            </v-card-title>
            <span class="heading ma-5">
              {{ asModel.statusDesc() }}
            </span>
          </v-card>
        </v-flex>

        <v-flex d-flex sx12 offset-sm1 sm9>
          <v-card flat>
            <v-card-title class="body-2" color="text--primary" box>
              Description
            </v-card-title>
            <span class="heading">
              {{ asModel.description }}
            </span>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex sx12 sm6 row wrap>
          <v-card flat>
            <v-card-title class="body-2" color="text--primary" >
              Rebalance Rules
            </v-card-title>
            <span class="heading ma-5">
              {{ asModel.rebalance.desc() }}
            </span>
          </v-card>
        </v-flex>
        <v-flex sx12 sm6 row wrap>
          <v-card flat>
            <v-card-title class="body-2" color="text--primary" >
              Execution Rules
            </v-card-title>
            <span class="heading ma-5">
              {{ asModel.executionRules.desc() }}
            </span>
          </v-card>
        </v-flex>
        <v-flex sx12 sm6 row wrap>
          <v-card flat>
            <v-card-title class="body-2" color="text--primary" >
              Trading Rules
            </v-card-title>
            <span class="heading ma-5">{{ asModel.tradingDesc }}</span>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Model from '@/classes/Model.class'
export default {
  computed: {
    ...mapGetters({
      model: 'models/model'
    }),
    asModel () {
      return new Model(this.model)
    }
  }
}
</script>

<style scoped>

.data {
  border-color: black;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  background-color: #ddd;
}

</style>
